// Read the quantity currently selected on the product page (dropdown or manual 50+ input).
// Returns 1 on pages without the quantity UI (collection, search, cart).
function tmWishlistSelectedQty() {
  var candidates = [
    document.querySelector(".jS_qty_input:not(.hidden) .pdpjs-qty__num"),
    document.querySelector(".jS_qty_input_mobile:not(.hidden) .pdpjs-qty__num_mobile"),
    document.querySelector(".dropdown_qtycls"),
    document.querySelector(".dropdown_qtycls_mobile"),
  ];
  for (var i = 0; i < candidates.length; i++) {
    var el = candidates[i];
    if (el && el.value && parseInt(el.value) > 0) {
      return parseInt(el.value);
    }
  }
  return 1;
}

// After adding to a list, make sure the selected quantity is stored on the new
// wishlist item via the /v3/quantity endpoint (in case /v1/add ignores quantity).
function tmWishlistSyncQtyAfterAdd(wishlistId, variantId, customerId, qty) {
  if (!qty || qty <= 1) return;
  var getPayload = JSON.stringify({
    id: "",
    shop: Shopify.shop,
    customer_id: customerId,
    ip: "",
    wishlist_share: "",
  });
  fetch("https://wishlist.webcontrive.com/wishlist-club/public/api/v1/get", {
    method: "POST",
    body: getPayload,
    headers: { "Content-Type": "text/plain" },
  })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      var lists = (res && res.data && res.data.wishlists) || [];
      var list = lists.find(function (l) { return l.id == wishlistId; });
      var item =
        list && list.wishlists
          ? list.wishlists.find(function (p) { return p.variant_id == variantId; })
          : null;
      if (item && item.quantity != qty) {
        fetch("https://wishlist.webcontrive.com/wishlist-club/public/api/v3/quantity", {
          method: "POST",
          body: JSON.stringify({
            quantityData: [{ id: item.id, quantity: qty }],
            shop: Shopify.shop,
            customer_id: customerId,
            ip: "",
          }),
          headers: { "Content-Type": "text/plain" },
        }).then(function () {
          // refresh the locally cached wishlist data so the detail page shows the new qty
          if (typeof getWishlistAPICall === "function") {
            getWishlistAPICall("", "");
          }
        });
      }
    })
    .catch(function () {});
}

// Briefly swaps an element's text (e.g. the cart page's "Add to List"
// trigger, or the popup's own "Save" button) to a status message, then
// restores whatever text it had before - the inline equivalent of the
// "Added to list" state swap used elsewhere in this file, so basket-save
// feedback never needs a native alert() popup.
function tmFlashButtonText(el, text, duration) {
  if (!el) return;
  var original = el.textContent;
  el.textContent = text;
  setTimeout(function () {
    el.textContent = original;
  }, duration || 2500);
}

// Cart page "Save Your Basket" - adds every line in window.tmBulkBasketItems
// (set by sections/new_cart_Section.liquid before opening this same popup)
// to each list the shopper checked, one add() + quantity sync per item per
// list. Sequential rather than Promise.all: a handful of basket lines is
// never slow enough to need the parallelism, and it avoids hammering this
// simple backend with a burst of concurrent writes from one click.
// Cart items are left untouched throughout - this only ever reads /cart.js,
// it never calls /cart/change.js.
async function tmBulkSaveBasketToLists() {
  var items = window.tmBulkBasketItems || [];
  var checkedBoxes = document.querySelectorAll(
    '.Wishlist_popup input[name="wishlist-radioGroup"]:checked'
  );
  var saveBtn = document.getElementById("SaveToList");
  if (!checkedBoxes.length) {
    tmFlashButtonText(saveBtn, "Please select a list");
    return;
  }
  if (!items.length) return;

  var customerId = tm_wishlist_customer_id;
  if (saveBtn) saveBtn.disabled = true;

  var wishlistIds = Array.from(checkedBoxes).map(function (cb) {
    return cb.value;
  });

  for (var w = 0; w < wishlistIds.length; w++) {
    var wishlistId = wishlistIds[w];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      try {
        await fetch(
          "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/add",
          {
            method: "POST",
            body: new URLSearchParams({
              shop: Shopify.shop,
              product_id: item.product_id,
              customer_id: customerId,
              wishlist_id: wishlistId,
              variant_id: item.variant_id,
              quantity: item.quantity,
            }),
          }
        );
        // Mirrors the single-product flow: /v1/add doesn't reliably persist
        // quantity on its own, and this also IS the "merge with an existing
        // item" step - it sets the list item's quantity to the basket's
        // current quantity rather than adding on top of whatever was there.
        tmWishlistSyncQtyAfterAdd(wishlistId, item.variant_id, customerId, item.quantity);
      } catch (e) {
        console.error("[save-basket] add failed", item, e);
      }
    }
  }

  window.tmBulkBasketSave = false;
  window.tmBulkBasketItems = null;
  if (saveBtn) saveBtn.disabled = false;
  $(".Wishlist_popup").removeClass("active");
  $("body").removeClass("layer_second");
  if (typeof getWishlistAPICall === "function") getWishlistAPICall("", "");
  document.querySelectorAll(".tm_save_basket-trigger .tm-wishlist-main").forEach(function (el) {
    tmFlashButtonText(el, "Added to List");
  });
}

// "Create a new List" counterpart to tmBulkSaveBasketToLists() above - the
// path a customer with zero existing lists reaches instead. Creates the
// list first, then runs the exact same per-item add+sync loop into it.
async function tmBulkCreateListAndSave() {
  var wishlistName = $("#New_list").val();
  var items = window.tmBulkBasketItems || [];
  if (!wishlistName) {
    $(".ListName label span").show();
    return;
  }
  if (!items.length) return;

  var customerId = tm_wishlist_customer_id;
  $("#create_list_main").addClass("loader");
  $(".ListName label span").hide();

  try {
    var createResponse = await fetch(
      "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/wishlist",
      {
        method: "POST",
        body: new URLSearchParams({
          shop: Shopify.shop,
          name: wishlistName,
          customer_id: customerId,
        }),
      }
    );
    var createResult = await createResponse.json();
    var newWishlistId = createResult.id;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      try {
        await fetch(
          "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/add",
          {
            method: "POST",
            body: new URLSearchParams({
              shop: Shopify.shop,
              product_id: item.product_id,
              customer_id: customerId,
              wishlist_id: newWishlistId,
              variant_id: item.variant_id,
              quantity: item.quantity,
            }),
          }
        );
        tmWishlistSyncQtyAfterAdd(newWishlistId, item.variant_id, customerId, item.quantity);
      } catch (e) {
        console.error("[save-basket] add failed", item, e);
      }
    }
  } catch (e) {
    console.error("[save-basket] create list failed", e);
  }

  $("#create_list_main").removeClass("loader");
  $(".Create_new_list #New_list").val("");
  window.tmBulkBasketSave = false;
  window.tmBulkBasketItems = null;
  $(".Wishlist_popup").removeClass("active").removeClass("add-ad-list");
  $("body").removeClass("layer_second");
  if (typeof getWishlistAPICall === "function") getWishlistAPICall("", "");
  document.querySelectorAll(".tm_save_basket-trigger .tm-wishlist-main").forEach(function (el) {
    tmFlashButtonText(el, "Added to List");
  });
}

function WishlistAPI() {
  $(".wishlist_lists .lists").append("");
  $(".tm_acc-usr-list ul").append("");
  var VariantObject = {};
  $(".custom_wishlist_button").each(function (e) {
    var ProductId = $(this).data("product_id");
    var VariantId = $(this).data("variant_id");
    VariantObject[VariantId] = ProductId;
  });
  var Data = {
    shop: Shopify.shop,
    product_ids: VariantObject,
    customer_id: Number($("body").data("customerid")),
  };
  console.log("Data-->", Data);
  // .wishlistFillbutton svg path,.MobileProductwishlistButton_after svg path{fill: ${WishlistButtonColorAfter}!important;stroke:none!important;}
  // =================== wishlist onload get data from the API for collection page ===================
  let popup_checked_if_wishlist_exist = async (payload, WishlistVatiantid) => {
    console.log("function_WishlistVatiantid", WishlistVatiantid);
    let tm_popup_list_radios = document.querySelectorAll(
      ".Wishlist_popup .list_radio"
    );
    tm_popup_list_radios.forEach((radio) => {
      const checkbox = radio.querySelector('input[name="wishlist-radioGroup"]');
      if (checkbox.classList.contains("tm_wishlist_product_added")) {
        checkbox.checked = false;
        checkbox.dataset.product_wishlist_id = "";
        checkbox.classList.remove("tm_wishlist_product_added");
      }
    });
    try {
      const response = await fetch(
        "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/get",
        {
          method: "POST",
          body: payload,
          headers: {
            "Content-Type": "text/plain",
          },
        }
      );
      const jsonData = await response.json();
      let wishlist_sections = jsonData.data.wishlists;
      if (wishlist_sections.length > 0) {
        // var list_array = []
        wishlist_sections.forEach((wishlist_section) => {
          let wishlist_section_items = wishlist_section.wishlists;
          // let wishlist_pro_lenght = wishlist_section_items.length;
          // list_array.push(wishlist_pro_lenght);
          if (wishlist_section_items.length > 0) {
            wishlist_section_items.forEach((wish_item) => {
              if (WishlistVatiantid == wish_item.variant_id) {
                tm_popup_list_radios.forEach((radio) => {
                  const checkbox = radio.querySelector(
                    'input[name="wishlist-radioGroup"]'
                  );

                  if (checkbox.value == wishlist_section.id) {
                    checkbox.checked = true;
                    checkbox.dataset.product_wishlist_id = wish_item.id;
                    checkbox.classList.add("tm_wishlist_product_added");
                  }
                });
              }
            });
          }
        });
        tm_popup_list_radios.forEach((radio, index) => {
          const checkbox = radio.querySelector(
            'input[name="wishlist-radioGroup"]'
          );
          if (!checkbox.classList.contains("tm_wishlist_product_added")) {
            checkbox.checked = false;
          }
          // var radio_label = $(radio).find(".item_count");
          // radio_label.text(`${list_array[index] || 0} items |`);
        });
      }
    } catch (error) {
      console.error("Error fetching wishlist data:", error);
    }
  };
  let popup_product_count = async (payload, WishlistVatiantid) => {
    let tm_popup_list_radios = document.querySelectorAll(
      ".Wishlist_popup .list_radio"
    );
    try {
      const response = await fetch(
        "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/get",
        {
          method: "POST",
          body: payload,
          headers: {
            "Content-Type": "text/plain",
          },
        }
      );
      const jsonData = await response.json();
      let wishlist_sections = jsonData.data.wishlists;
      if (wishlist_sections.length > 0) {
        var list_array = [];
        wishlist_sections.forEach((wishlist_section) => {
          let wishlist_section_items = wishlist_section.wishlists;
          let wishlist_pro_lenght = wishlist_section_items.length;
          list_array.push(wishlist_pro_lenght);
        });
        tm_popup_list_radios.forEach((radio, index) => {
          var radio_label = $(radio).find(".item_count");
          if (list_array[index] > 1) {
            radio_label.text(`${list_array[index] || 0} items |`);
          } else {
            radio_label.text(`${list_array[index] || 0} item |`);
          }
        });
      }
      // Hide the loading overlay once the fetch resolves, regardless of
      // whether the customer has any lists yet — this used to sit inside
      // the "wishlist_sections.length > 0" branch's forEach, so a customer
      // with zero lists (e.g. adding to a list for the first time) never
      // reached this line and the overlay stayed stuck forever, blocking
      // the whole "Add to List" popup.
      $("body").removeClass("cms-test");
    } catch (error) {
      $("body").removeClass("cms-test");
      console.error("Error fetching wishlist data:", error);
    }
  };
  if (
    $("body").hasClass("collection") ||
    $("body").hasClass("customer_login")
  ) {
    $.ajax({
      type: "POST",
      url: "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/setting1",
      data: Data,
      dataType: "json",
      success: function (response) {
        // Dynamic css js starts from here
        var WishlistButtonColorBefore =
          response.data.setting.button_border_color_before;
        var WishlistButtonColorAfter = response.data.setting.button_color_after;
        var WishlistBackgroundcolor =
          response.data.setting.button_bg_color_before;
        var DynamicStyle = `<style>
      .wishlistButton svg path:last-child,.MobileProductwishlistButton svg path:last-child{fill: #000!important;}
      .wishlistButton svg path:first-child,.MobileProductwishlistButton svg path:first-child{fill:transparent;}
      .wishlistFillbutton svg path:last-child,.MobileProductwishlistButton svg path:last-child{fill: #000!important;}
      .wishlistFillbutton svg path:first-child,.MobileProductwishlistButton svg path:first-child{fill: transparent!important;}
      </style>`;
        $("head").append(DynamicStyle);
        console.log("response", response);
        var Products = response.data.products;
        var wishLists = response.data.wishlist;

        wishLists.forEach(function (list, index) {
          if (index < 5) {
            $(".tm_acc-usr-list ul").append(
              "<li><a href='/pages/wishlist?wishlistview=" +
                list.id +
                "' class='tm_sm-font'>" +
                list.name +
                "</a></li>"
            );
          }
        });
        if (wishLists.length > 5) {
          $(".tm_acc-usr-list ul").append(
            "<li><a href='/pages/wishlist' class='tm_sm-font tm-view-more'>View more Lists ></a></li>"
          );
        }

        $(".tm_acc-usr-list ul a").on("click", function (event) {
          var list_name = $(this).text().trim();
          console.log("list_name", list_name);
          localStorage.setItem("th_wishlist_global_variable", list_name);
        });

        $(Products).each(function () {
          var ProductVariantId = this.shopify_variant_id;
          var ProductId = this.shopify_product_id;
          var WishlistStatus = this.wishlisted;
          var wishListSelector = $(
            ".custom_wishlist_button[data-variant_id = " +
              ProductVariantId +
              "]"
          );
          var wishlistEmptyButton = `<span class="wishlistButton" data-variantid="${ProductVariantId}" data-productid="${ProductId}" data-customerid="${Data.customer_id}"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                      <g clip-path="url(#clip0_5643_3789)">
                                      <path d="M18.4134 2.83508C17.3781 1.71219 15.9575 1.09375 14.413 1.09375C13.2585 1.09375 12.2012 1.45874 11.2704 2.1785C10.8008 2.54181 10.3752 2.9863 10 3.5051C9.62494 2.98645 9.19922 2.54181 8.7294 2.1785C7.79877 1.45874 6.74149 1.09375 5.58701 1.09375C4.04251 1.09375 2.62177 1.71219 1.58646 2.83508C0.563507 3.94485 0 5.46097 0 7.10434C0 8.79578 0.630341 10.3441 1.98364 11.9771C3.19427 13.4378 4.93423 14.9207 6.94916 16.6377C7.63718 17.2241 8.41705 17.8888 9.22684 18.5968C9.44077 18.7842 9.71527 18.8873 10 18.8873C10.2846 18.8873 10.5592 18.7842 10.7729 18.5971C11.5826 17.8889 12.363 17.224 13.0513 16.6373C15.0659 14.9205 16.8059 13.4378 18.0165 11.9769C19.3698 10.3441 20 8.79578 20 7.10419C20 5.46097 19.4365 3.94485 18.4134 2.83508Z" fill="#FF819C"/>
                                      <path d="M10 18.8873C9.71527 18.8873 9.44077 18.7842 9.22684 18.5968C8.41888 17.8903 7.63992 17.2264 6.95267 16.6408L6.94916 16.6377C4.93423 14.9207 3.19427 13.4378 1.98364 11.9771C0.630341 10.3441 0 8.79578 0 7.10434C0 5.46097 0.563507 3.94485 1.58661 2.83508C2.62192 1.71219 4.04251 1.09375 5.58716 1.09375C6.74164 1.09375 7.79892 1.45874 8.72955 2.1785C9.19922 2.54181 9.62494 2.98645 10 3.5051C10.3752 2.98645 10.8008 2.54181 11.2706 2.1785C12.2012 1.45874 13.2585 1.09375 14.413 1.09375C15.9575 1.09375 17.3782 1.71219 18.4135 2.83508C19.4366 3.94485 20 5.46097 20 7.10434C20 8.79578 19.3698 10.3441 18.0165 11.9769C16.8059 13.4378 15.0661 14.9205 13.0515 16.6374C12.363 17.224 11.5828 17.8889 10.773 18.5971C10.5592 18.7842 10.2846 18.8873 10 18.8873V18.8873ZM5.58716 2.26532C4.37363 2.26532 3.25882 2.74963 2.44781 3.62915C1.62476 4.52194 1.17142 5.75607 1.17142 7.10434C1.17142 8.52692 1.70013 9.79919 2.88559 11.2296C4.03137 12.6122 5.73563 14.0645 7.70889 15.7462L7.71255 15.7492C8.4024 16.3371 9.18442 17.0036 9.99832 17.7153C10.8171 17.0023 11.6003 16.3347 12.2916 15.7458C14.2647 14.0642 15.9688 12.6122 17.1146 11.2296C18.2999 9.79919 18.8286 8.52692 18.8286 7.10434C18.8286 5.75607 18.3752 4.52194 17.5522 3.62915C16.7413 2.74963 15.6264 2.26532 14.413 2.26532C13.524 2.26532 12.7078 2.54791 11.9872 3.10516C11.3449 3.60199 10.8975 4.23004 10.6352 4.66949C10.5003 4.89548 10.2629 5.03036 10 5.03036C9.73709 5.03036 9.49966 4.89548 9.36478 4.66949C9.10263 4.23004 8.65524 3.60199 8.01285 3.10516C7.29218 2.54791 6.47598 2.26532 5.58716 2.26532V2.26532Z" fill="#616161"/>
                                      </g>
                                      <defs>
                                      <clipPath id="clip0_5643_3789">
                                      <rect width="20" height="20" fill="white"/>
                                      </clipPath>
                                      </defs>
                                      </svg></span>`;
          var WishlistFillButton = `<span class="wishlistFillbutton" data-variantid="${ProductVariantId}" data-productid="${ProductId}" data-customerid="${Data.customer_id}">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                      <path d="M18.2849 8.26802C21.2839 4.26612 14.2838 -1.73517 10.2848 5.26483C6.05908 -1.45699 -1.5 3.5 1.78337 8.26802L10.059 18.543L18.2849 8.26802Z" stroke="black"/>
                                      </svg>
                                    </span>`;

          if (WishlistStatus) {
            $(wishListSelector).html(WishlistFillButton);
          } else {
            $(wishListSelector).html(wishlistEmptyButton);
          }
        });

        // append wishlist list to head on load withlink
        $(wishLists).each(function () {
          var wishlistName = this.name;
          var ListId = this.id;
          var List_update = this.updated_at;
          var ListDate = List_update.split(" ")[0];
          var ListUpdatedyear = ListDate.split("-")[0];
          var ListUpdatedMonth = ListDate.split("-")[1];
          var ListUpdatedDay = ListDate.split("-")[2];
          var ListUpdatedDate = `${ListUpdatedDay}/${ListUpdatedMonth}/${ListUpdatedyear}`;
          console.log("wishlist-for-item-count", this);
          var listoptions = `<div class="list_radio test new-test-1">
          <p class="count"></p>
          <input type="checkbox" id="list-${ListId}" name="wishlist-radioGroup" value="${ListId}">
          <label for="list-${ListId}">
            <p>${wishlistName}</p>
            <span><span class="item_count"></span> Updated  ${ListUpdatedDate}</span>
          </label>
        </div>`;
          $(".wishlist_lists .lists").append(listoptions);
          // $(".tm_acc-usr-list ul").append("<li><a href='/apps/wishlist' class='tm_sm-font'>" + wishlistName + "</a></li>");
          // $(".tm_acc-usr-list ul").append(
          //   "<li><a href='/pages/wishlist?wishlistview=" +
          //     ListId +
          //     "' class='tm_sm-font'>" +
          //     wishlistName +
          //     "</a></li>"
          // );
          // account dropdown max 5 + view more
          
          // $(".tm_acc-usr-list ul a").on("click", function (event) {
          //   var list_name = $(this).text().trim();
          //   console.log("list_name", list_name);
          //   localStorage.setItem("th_wishlist_global_variable", list_name);
          // });
        });

        // listinputChange event
        $(document).on(
          "change",
          "input[name='wishlist-radioGroup']",
          function () {
            var CheckedListId = this.value;
            $("#SaveToList").attr("data-listid", CheckedListId);
          }
        );

        // WishlistAddjs starts from here
        $(document).on("click", ".wishlistButton", function () {
          let tm_popup_list_radios = document.querySelectorAll(
            ".Wishlist_popup .list_radio"
          );
          tm_popup_list_radios.forEach((radio) => {
            const checkbox = radio.querySelector(
              'input[name="wishlist-radioGroup"]'
            );
            if (checkbox.classList.contains("tm_wishlist_product_added")) {
              checkbox.checked = false;
              checkbox.dataset.product_wishlist_id = "";
              checkbox.classList.remove("tm_wishlist_product_added");
            }
          });
          let WishlistVatiantid = $(this).data("variantid");
          let WishlistProductid = $(this).data("productid");
          let WishlistCustomerId = $(this).data("customerid");
          let CurrentButton = $(this);

          $("#SaveToList").attr("data-variantid", WishlistVatiantid);
          $("#SaveToList").attr("data-productid", WishlistProductid);
          $("#SaveToList").attr("data-customerid", WishlistCustomerId);
          $("#create_list_main").attr("data-variantid", WishlistVatiantid);
          $("#create_list_main").attr("data-productid", WishlistProductid);
          $("#create_list_main").attr("data-customerid", WishlistCustomerId);
          $(".Wishlist_popup").addClass("active");
          $("input[name='wishlist-radioGroup']").prop("checked", false);
          if ($(".Create_new_list").hasClass("active")) {
            $(".Create_new_list").removeClass("active");
            $(".wishlist_lists").addClass("active");
            $("#create_list").show();
          }
          $("body").addClass("layer_second");
          const payload = JSON.stringify({
            shop: Shopify.shop,
            customer_id: WishlistCustomerId,
            ip: "",
            wishlist_share: "",
          });
          let productSrc = $(this).parent().attr("data-src");
          let productTitle = $(this).parent().attr("data-productname");
          let productPrice = $(this).parent().attr("data-productprice");
          let ProductVariant = $(this).parent().attr("data-variant");
          let ProductVendor = $(this).parent().attr("data-productVendor");
          let ProductModel = $(this).parent().attr("data-productmodel");
          var ProductModelHtml;
          if (ProductModel) {
            ProductModelHtml = `<p>Model: ${ProductModel}</p>`;
          } else {
            ProductModelHtml = "";
          }
          var SelectedProduct = `
            <div class="pro-select">
              <div class="pro_img">
                <img src="${productSrc}" alt="proImage">
              </div>
              <div class="pro-infor">
                <h3>${productTitle}</h3>
                <p class="selectpro_price">${productPrice} <span>ex.VAT</span></p>
                ${ProductModelHtml}
                <p>Variant: ${ProductVariant}</p>
              </div>
            </div>`;
          $(".selected_product .product_selected").html(SelectedProduct);
          popup_product_count(payload, WishlistVatiantid);
        });

        // save Button click js starts from here

        $(document).on("click", "#SaveToList", function () {
          // Cart page's "Save Your Basket" (sections/new_cart_Section.liquid)
          // reuses this same popup/button for a whole-basket save rather than
          // the single product/variant this handler normally saves - branch
          // off before any of that single-item logic runs.
          if (window.tmBulkBasketSave) {
            tmBulkSaveBasketToLists();
            return;
          }
          let list_radios = document.querySelectorAll(
            ".Wishlist_popup .list_radio"
          );
          if (list_radios.length > 0) {
            let radio_unchecked_count = 0;
            list_radios.forEach((list_radio) => {
              radio_unchecked_count += 1;
              const checkbox = list_radio.querySelector(
                'input[name="wishlist-radioGroup"]'
              );
              if (
                checkbox.checked &&
                !checkbox.classList.contains("tm_wishlist_product_added")
              ) {
                let WishlistVatiantid_new = $(this).attr("data-variantid");
                let WishlistProductid = $(this).attr("data-productid");
                let WishlistCustomerId = $(this).data("customerid");
                let WishlistId = checkbox.value;
                // if customer has already created wishlist thenthis will work first
                let AddwishlistData = {
                  shop: Shopify.shop,
                  product_id: WishlistProductid,
                  customer_id: WishlistCustomerId,
                  wishlist_id: WishlistId,
                  variant_id: WishlistVatiantid_new,
                  quantity: tmWishlistSelectedQty(),
                };
                console.log("New_AddwishlistData", AddwishlistData);
                $.ajax({
                  type: "POST",
                  url: "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/add",
                  data: AddwishlistData,
                  dataType: "json",
                  success: function (response) {
                    tmWishlistSyncQtyAfterAdd(
                      WishlistId,
                      WishlistVatiantid_new,
                      WishlistCustomerId,
                      AddwishlistData.quantity
                    );
                    $(
                      ".wishlistButton[data-variantid='" +
                        WishlistVatiantid_new +
                        "']"
                    ).addClass("wishlistFillbutton");
                    $(
                      ".cart_page_wishlist[data-variant_id='" +
                        WishlistVatiantid_new +
                        "']"
                    ).html("Added to list");
                    // $(".MobileProductwishlistButton[data-variant_id='"+ WishlistVatiantid_new +"']").removeClass("MobileProductwishlistButton").addClass("MobileProductwishlistButton_after");
                    // $(".second_wishlist_button[data-variant_id='"+ WishlistVatiantid_new +"']").find(".th_wl_button").removeClass("th_wl_button").addClass("th_wl_button_after");
                    $("body").removeClass("layer_second");
                    if ($("body").hasClass("cart")) {
                      location.reload();
                    }
                    getWishlistAPICall();
                    $(".Wishlist_popup").removeClass("active");
                  },
                });
              }
            });
            if (list_radios.length == radio_unchecked_count) {
              $(".Wishlist_popup").removeClass("active");
              $("body").removeClass("layer_second");
            }
          }
          if (localStorage.getItem("saveForLater") === "true") {
            var VariantID = $(this).attr("data-variantid");
            if (VariantID) {
              localStorage.setItem("SaveLater_id", VariantID);
              console.log(`SaveLater_id set to: ${VariantID}`);
            } else {
              console.log("data-variantid attribute not found on #SaveToList");
            }
          } else {
            console.log("saveForLater is not set to true in localStorage");
          }
        });

        // createList js starts from here
        $(document).on("click", "#create_list_main", function () {
          // Same branch as #SaveToList above - a customer with zero existing
          // lists reaches "Create a new List" instead, and the whole-basket
          // save needs its own create-then-add-every-line path rather than
          // the single data-variantid/data-productid this handler normally
          // reads off the button (never set for a basket-wide save).
          if (window.tmBulkBasketSave) {
            tmBulkCreateListAndSave();
            return;
          }
          let WishlistVatiantid = $(this).attr("data-variantid");
          let WishlistProductid = $(this).attr("data-productid");
          let WishlistCustomerId = $(this).attr("data-customerid");
          let wishlistName = $("#New_list").val();
          let matchliustName = false;
          $(wishLists).each(function () {
            let name = this.name;
            if (wishlistName == name) {
              matchliustName = true;
              return false;
            }
          });
          let CreateList = {
            shop: Shopify.shop,
            name: wishlistName,
            customer_id: WishlistCustomerId,
          };
          if (matchliustName == false) {
            $("#create_list_main").addClass("loader");
            $(".ListName label span").hide();
            $.ajax({
              type: "POST",
              url: "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/wishlist",
              data: CreateList,
              dataType: "json",
              success: function (response) {
                var AddProductToWishlist = response.id;
                let AddwishlistData = {
                  shop: Shopify.shop,
                  product_id: WishlistProductid,
                  customer_id: WishlistCustomerId,
                  wishlist_id: AddProductToWishlist,
                  variant_id: WishlistVatiantid,
                  quantity: tmWishlistSelectedQty(),
                };
                $.ajax({
                  type: "POST",
                  url: "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/add",
                  data: AddwishlistData,
                  dataType: "json",
                  success: function (response) {
                    tmWishlistSyncQtyAfterAdd(
                      AddProductToWishlist,
                      WishlistVatiantid,
                      WishlistCustomerId,
                      AddwishlistData.quantity
                    );
                    $.ajax({
                      type: "POST",
                      url: "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/setting1",
                      data: Data,
                      dataType: "json",
                      success: function (response) {
                        $("#create_list_main").removeClass("loader");
                        $(".Create_new_list #New_list").val("");
                        var UpdateWishlist = response.data.wishlist;
                        $(".wishlist_lists .lists").html("");
                        $(".tm_acc-usr-list ul").html("");

                        // account dropdown max 5 + view more
                        UpdateWishlist.forEach(function (list, index) {
                          if (index < 5) {
                            $(".tm_acc-usr-list ul").append(
                              "<li><a href='/pages/wishlist?wishlistview=" +
                                list.id +
                                "' class='tm_sm-font'>" +
                                list.name +
                                "</a></li>"
                            );
                          }
                        });
                        if (UpdateWishlist.length > 5) {
                          $(".tm_acc-usr-list ul").append(
                            "<li><a href='/pages/wishlist' class='tm_sm-font tm-view-more'>View more Lists ></a></li>"
                          );
                        }

                        $(".tm_acc-usr-list ul a").on(
                          "click",
                          function (event) {
                            var list_name = $(this).text().trim();
                            console.log("list_name", list_name);
                            localStorage.setItem(
                              "th_wishlist_global_variable",
                              list_name
                            );
                          }
                        );

                        $(UpdateWishlist).each(function () {
                          var wishlistName = this.name;
                          var ListId = this.id;
                          var List_update = this.updated_at;
                          var ListDate = List_update.split(" ")[0];
                          var ListUpdatedyear = ListDate.split("-")[0];
                          var ListUpdatedMonth = ListDate.split("-")[1];
                          var ListUpdatedDay = ListDate.split("-")[2];
                          var ListUpdatedDate = `${ListUpdatedDay}/${ListUpdatedMonth}/${ListUpdatedyear}`;
                          var listoptions = `<div class="list_radio test">
                                <input type="checkbox" id="list-${ListId}" name="wishlist-radioGroup" value="${ListId}">
                                <label for="list-${ListId}">
                                  <p>${wishlistName}</p>
                                  <span>Updated ${ListUpdatedDate}</span>
                                </label>
                              </div>`;
                          $(".wishlist_lists .lists").append(listoptions);
                          // $(".tm_acc-usr-list ul").append(
                          //   "<li><a href='/pages/wishlist?wishlistview=" +
                          //     ListId +
                          //     "' class='tm_sm-font'>" +
                          //     wishlistName +
                          //     "</a></li>"
                          // );
                          // $(".tm_acc-usr-list ul a").on(
                          //   "click",
                          //   function (event) {
                          //     var list_name = $(this).text().trim();
                          //     console.log("list_name", list_name);
                          //     localStorage.setItem(
                          //       "th_wishlist_global_variable",
                          //       list_name
                          //     );
                          //   }
                          // );
                        });
                        getWishlistAPICall();
                        if ($("body").hasClass("cart")) {
                          location.reload();
                        }
                        $(".Wishlist_popup").removeClass("active");
                        $("body").removeClass("layer_second");
                      },
                    });

                    $(
                      ".wishlistButton[data-variantid='" +
                        WishlistVatiantid +
                        "']"
                    ).addClass("wishlistFillbutton");
                  },
                });
              },
            });
          } else {
            $(".ListName label span").show();
          }
          if (localStorage.getItem("saveForLater") === "true") {
            var VariantID = $(this).attr("data-variantid");
            if (VariantID) {
              localStorage.setItem("SaveLater_id", VariantID);
              console.log(`SaveLater_id set to: ${VariantID}`);
            } else {
              console.log("data-variantid attribute not found on #SaveToList");
            }
          } else {
            console.log("saveForLater is not set to true in localStorage");
          }
          // $("#New_list").val('')
        });

        let wishlist_icon = "";
        $(document).on("click", ".wishlistFillbutton", function () {
          let WishlistVatiantid = $(this).data("variantid");
          let WishlistProductid = $(this).data("productid");
          let WishlistCustomerId = $(this).data("customerid");
          $("#SaveToList").attr("data-variantid", WishlistVatiantid);
          $("#SaveToList").attr("data-productid", WishlistProductid);
          $("#SaveToList").attr("data-customerid", WishlistCustomerId);
          let CurrentButton = $(this);
          wishlist_icon = $(this);
          $(".Wishlist_popup").addClass("active");
          $("body").addClass("layer_second");
          const payload = JSON.stringify({
            shop: Shopify.shop,
            customer_id: WishlistCustomerId,
            ip: "",
            wishlist_share: "",
          });
          popup_checked_if_wishlist_exist(payload, WishlistVatiantid);
          popup_product_count(payload, WishlistVatiantid);
          let tm_popup_list_radios = document.querySelectorAll(
            ".Wishlist_popup .list_radio"
          );
          tm_popup_list_radios.forEach((radio) => {
            const checkbox = radio.querySelector(
              'input[name="wishlist-radioGroup"]'
            );
            checkbox.addEventListener("change", () => {
              const selectedInputs = document.querySelectorAll(
                '.Wishlist_popup .list_radio input[name="wishlist-radioGroup"]:checked'
              );
              console.log("wishlist_icon-->>", wishlist_icon);
              if (selectedInputs.length < 1) {
                wishlist_icon.removeClass("wishlistFillbutton");
                wishlist_icon.addClass("wishlistButton");
              }
              popup_product_count(payload, WishlistVatiantid);
            });
          });
          tm_remove_wishlist_product_from_popup_fun();
        });
        $(document).on("click", ".cart_fill_btn", function () {
          let WishlistCustomerId = Number($("body").data("customerid"));
          let WishlistVariantId = $(this)
            .closest(".tm_shp_cart-item ")
            .attr("data-idth_do");
          console.log("click->-WishlistVariantId", WishlistVariantId);
          const payload = JSON.stringify({
            shop: Shopify.shop,
            customer_id: WishlistCustomerId,
            ip: "",
            wishlist_share: "",
          });
          popup_checked_if_wishlist_exist(payload, WishlistVariantId);
        });

        // removeItemWishlist jhs starts from here
        let tm_remove_wishlist_product_from_popup_fun = () => {
          let tm_popup_list_radios = document.querySelectorAll(
            ".Wishlist_popup .list_radio"
          );
          tm_popup_list_radios.forEach((radio) => {
            const checkbox = radio.querySelector(
              'input[name="wishlist-radioGroup"]'
            );
            checkbox.addEventListener("change", () => {
              // const selectedInputs = document.querySelectorAll('.Wishlist_popup .list_radio input[name="wishlist-radioGroup"]:checked');
              // // if(selectedInputs.length <= 1){

              // // }
              if (checkbox.classList.length > 0) {
                if (checkbox.classList.contains("tm_wishlist_product_added")) {
                  let tm_product_wishlist_id =
                    checkbox.dataset.product_wishlist_id;
                  let AddwishlistData = {
                    id: tm_product_wishlist_id,
                    shop: Shopify.shop,
                    customer_id: $("#SaveToList").attr("data-customerid"),
                  };
                  $.ajax({
                    type: "POST",
                    url: "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/remove",
                    data: AddwishlistData,
                    dataType: "json",
                    success: function (response) {
                      checkbox.classList.remove("tm_wishlist_product_added");
                      // $(CurrentButton).removeClass("wishlistFillbutton").addClass("wishlistButton");
                      // $(".Remove_item_popup").addClass("active");
                      console.log("response.data.total", response.data.total);
                      if (!$("body").hasClass("cart")) {
                        if (response.data.total == 0) {
                          wishlist_icon[0].classList.remove(
                            "wishlistFillbutton"
                          );
                          wishlist_icon[0].classList.add("wishlistButton");
                        }
                      }
                      $(document).on("click", "#SaveToList", function () {
                        if ($("body").hasClass("cart")) {
                          location.reload();
                        }
                      });
                      // setTimeout(function(){
                      //   $(".Remove_item_popup").removeClass("active");
                      // }, 1000);
                    },
                  });
                }
              }
            });
          });
        };

        tm_remove_wishlist_product_from_popup_fun();
      },
    });
  }
  // =================== wishlist on load data for product page js starts from here ==================

  
  if ($("body").hasClass("product") && $("body").hasClass("customer_login")) {
    var ProductPageVariantId = $(".tm_add_to-list").data("variant_id");
    var ProductPageProductId = $(".tm_add_to-list").data("product_id");
    var ProductObject = {};
    ProductObject[ProductPageVariantId] = ProductPageProductId;
    var productData = {
      shop: Shopify.shop,
      product_ids: ProductObject,
      customer_id: Number($("body").data("customerid")),
    };
    // .tm_add_to-list ("Add to List") renders empty in the Liquid markup —
    // it only gets its contents (and its click handler, registered inside
    // "success" below) from this request. Previously there was no timeout
    // and no error handling, so on a slow or dropped connection the request
    // could hang indefinitely ("very slow to load") or fail silently,
    // leaving the button permanently empty ("does not open" / "disappeared
    // after refresh") with no retry. Wrap it so a slow/failed request is
    // retried automatically instead of leaving the customer with nothing.
    //
    // The timeout is deliberately long. This endpoint answers correctly
    // (200, full payload) but has been measured at 21–59s, so the previous
    // 8s ceiling aborted every attempt — all three retries finished before
    // the first response could arrive and the button never rendered at all.
    // A ceiling above the observed worst case means a slow answer still
    // produces a button instead of nothing. This is a safety net, not a
    // fix: a 20s+ wishlist API is a server-side problem worth solving at
    // the app, and once it is, this can come back down.
    //
    // Confirmed live (browser console, logged-in session): this endpoint
    // also intermittently rejects an otherwise-valid, correctly-formed
    // request outright with a 403 (surfaced to JS as a CORS failure, since
    // the 403 response carries no Access-Control-Allow-Origin header) -
    // same request succeeded seconds later. That's a fast failure, not a
    // slow one, so it deserves more attempts at a shorter timeout rather
    // than burning the same long 65s ceiling meant for genuine slowness -
    // and a short backoff between attempts gives a momentary rate-limit/
    // rejection a better chance to have cleared by the next try.
    var loadWishlistAddToListButton = function (attemptsLeft, retryDelayMs) {
      retryDelayMs = retryDelayMs || 1500;
      $.ajax({
        type: "POST",
        url: "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/setting1",
        data: productData,
        dataType: "json",
        timeout: 65000,
        error: function (jqXHR, textStatus) {
          console.error(
            "Add to List failed to load (" + textStatus + ", HTTP " + jqXHR.status + "), attempts left:",
            attemptsLeft
          );
          if (attemptsLeft > 0) {
            setTimeout(function () {
              loadWishlistAddToListButton(attemptsLeft - 1, Math.min(retryDelayMs * 2, 8000));
            }, retryDelayMs);
          }
        },
        success: function (response) {
        var wishLists = response.data.wishlist;
        var productData = response.data.products[0];
        var ProductMainVariantId = productData.shopify_variant_id;
        var ProductMainId = productData.shopify_product_id;
        var ProductWishlisted = productData.wishlisted;
        var AppendWishlistButton, MobileWishlistButton;

        AppendWishlistButton = `<div class="second_wishlist_button" data-product_id="${ProductMainId}" data-variant_id="${ProductMainVariantId}">
                                  <div class="tm-wishlist-container">
                                    <div class="tm-wishlist-main th_wl_button_trigger">Add to List</div>
                                    <div class="tm-wishlist-arrow">
                                      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L5 5L9 1" stroke="#0F1111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                    </div>
                                    <div class="tm-wishlist-dropdown" >
                                      <ul class="tm-wishlist-dropdown-items">
                                        ${wishLists.map(list => 
                                          `<li class="tm-wishlist-item ${list.is_active ? 'active' : ''}" data-list-id="${list.id}">
                                            <a href="/pages/wishlist?wishlistview=${list.id}">${list.name}</a>
                                          </li>`
                                        ).join('')}
                                      </ul>
                                      <div class="tm-wishlist-create-new" id="create_new_list_trigger">
                                        <a href="#"><span>+</span> Create another Wish List</a>
                                        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M1 1L5 5L1 9" stroke="#555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                </div>`;
        MobileWishlistButton = `<span class="test2 MobileProductwishlistButton" data-product_id="${ProductMainId}" data-variant_id="${ProductMainVariantId}">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.44934 9.25603C3.74195 11.886 9.10251 17.6834 12.2073 21.2317C14.2172 19.2317 16.2172 17.7317 21.5218 11.0302C25.2172 5.23172 18.7172 0.231717 15.3121 2.60286C14.6025 2.95769 13.2271 4.19934 12.2172 5.23174C11.2271 4.19934 10.7172 3.73172 9.10251 2.60286C4.21721 0.231739 0.717205 5.73174 2.44934 9.25603Z" stroke="#0F1111" stroke-width="2"/>
          </svg>
        </span>`;

        $(".tm_add_to-list").empty().append(AppendWishlistButton);
        $(".mobile_wishlist_button").empty().append(MobileWishlistButton);

        // addwishlist button js starts from here
        $(document).on(
          "click",
          ".second_wishlist_button .th_wl_button_trigger",
          function (e) {
            e.preventDefault();
            let WishlistVatiantid = $(this)
              .parents(".second_wishlist_button")
              .data("variant_id");
            let WishlistProductid = $(this)
              .parents(".second_wishlist_button")
              .data("product_id");
            let WishlistCustomerId = Number($("body").data("customerid"));
            let CurrentButton = $(this);
            $("#SaveToList").attr("data-variantid", WishlistVatiantid);
            $("#SaveToList").attr("data-productid", WishlistProductid);
            $("#SaveToList").attr("data-customerid", WishlistCustomerId);
            $("#create_list_main").attr("data-variantid", WishlistVatiantid);
            $("#create_list_main").attr("data-productid", WishlistProductid);
            $("#create_list_main").attr("data-customerid", WishlistCustomerId);
            $(".Wishlist_popup").addClass("active");
            $("input[name='wishlist-radioGroup']").prop("checked", false);
            if ($(".Create_new_list").hasClass("active")) {
              $(".Create_new_list").removeClass("active");
              $(".wishlist_lists").addClass("active");
              $("#create_list").show();
            }
            $("body").addClass("layer_second");
          $("body").addClass("cms-test");
            let productSrc = $(this)
              .parents(".tm_add_to-list")
              .attr("data-src");
            let productTitle = $(this)
              .parents(".tm_add_to-list")
              .attr("data-productname");
            let productPrice = $(this)
              .parents(".tm_add_to-list")
              .attr("data-productprice");
            let ProductVariant = $(this)
              .parents(".tm_add_to-list")
              .attr("data-variant");
            let ProductVendor = $(this)
              .parents(".tm_add_to-list")
              .attr("data-productVendor");
            let ProductModel = $(this)
              .parents(".tm_add_to-list")
              .attr("data-productmodel");
            var ProductModelHtml;
            if (ProductModel) {
              ProductModelHtml = `<p>Model: ${ProductModel}</p>`;
            } else {
              ProductModelHtml = "";
            }
            var SelectedProduct = `
            <div class="pro-select">
              <div class="pro_img">
                <img src="${productSrc}" alt="proImage">
              </div>
              <div class="pro-infor">
                <h3>${productTitle}</h3>
                <p class="selectpro_price">${productPrice} <span>ex.VAT</span></p>
                ${ProductModelHtml}
                <p>Variant: ${ProductVariant}</p>
              </div>
            </div>`;
            $(".selected_product .product_selected").html(SelectedProduct);
           
            const payload = JSON.stringify({
              shop: Shopify.shop,
              customer_id: WishlistCustomerId,
              ip: "",
              wishlist_share: "",
            });
            popup_checked_if_wishlist_exist(payload, WishlistVatiantid);
            popup_product_count(payload, WishlistVatiantid);
          }
        );

        // // Arrow click shows dropdown
        // $(document).on("click", ".tm-wishlist-arrow", function(e) {
        //   e.stopPropagation();
        //   $(this).siblings(".tm-wishlist-dropdown").toggle();
        // });

        // // Close dropdown when clicking outside
        // $(document).on("click", function() {
        //   $(".tm-wishlist-dropdown").hide();
        // });

        // // Trigger create new list popup from dropdown
        // $(document).on("click", "#create_new_list_trigger", function(e) {
        //   e.preventDefault();
        //   e.stopPropagation();
        //   $(".tm-wishlist-dropdown").hide();
        //   $(".second_wishlist_button .th_wl_button_trigger").click(); // Open the main popup
        //   setTimeout(function() {
        //     $("#create_list").click();
        //   }, 100);
        // });


        // Arrow click shows dropdown
        $(document).on("click", ".tm-wishlist-arrow", function(e) {
          e.stopPropagation();

          let $dropdown = $(this).siblings(".tm-wishlist-dropdown");
          let $parent = $(this).closest(".second_wishlist_button");

          // Close all other dropdowns first
          $(".tm-wishlist-dropdown").not($dropdown).removeClass("active");
          $(".second_wishlist_button").not($parent).removeClass("open");

          // Toggle active class
          $dropdown.toggleClass("active");
          $parent.toggleClass("open");
        });

        // Close dropdown when clicking outside
        $(document).on("click", function() {
          $(".tm-wishlist-dropdown").removeClass("active");
          $(".second_wishlist_button").removeClass("open");
        });

        // Prevent dropdown click from closing
        $(document).on("click", ".tm-wishlist-dropdown", function(e) {
          e.stopPropagation();
        });

        // Trigger create new list popup from dropdown
        $(document).on("click", "#create_new_list_trigger", function(e) {
          e.preventDefault();
          e.stopPropagation();

          $(".tm-wishlist-dropdown").removeClass("active");

          $(".second_wishlist_button .th_wl_button_trigger").click(); // Open the main popup
          setTimeout(function() {
            $("#create_list").click();
          }, 100);
        });

        // removeWishlist button js starts from here

        // mobile addwishlist button js starts from here
        $(document).on("click", ".MobileProductwishlistButton", function (e) {
          e.preventDefault();
          let WishlistVatiantid = $(this).data("variant_id");
          let WishlistProductid = $(this).data("product_id");
          let WishlistCustomerId = Number($("body").data("customerid"));
          let CurrentButton = $(this);
          $("#SaveToList").attr("data-variantid", WishlistVatiantid);
          $("#SaveToList").attr("data-productid", WishlistProductid);
          $("#SaveToList").attr("data-customerid", WishlistCustomerId);
          $("#create_list_main").attr("data-variantid", WishlistVatiantid);
          $("#create_list_main").attr("data-productid", WishlistProductid);
          $("#create_list_main").attr("data-customerid", WishlistCustomerId);
          $(".Wishlist_popup").addClass("active");
          $("input[name='wishlist-radioGroup']").prop("checked", false);
          if ($(".Create_new_list").hasClass("active")) {
            $(".Create_new_list").removeClass("active");
            $(".wishlist_lists").addClass("active");
            $("#create_list").show();
          }
          $("body").addClass("layer_second");
          $("body").addClass("cms-test");
          let productSrc = $(this)
            .parents(".mobile_wishlist_button")
            .attr("data-src");
          let productTitle = $(this)
            .parents(".mobile_wishlist_button")
            .attr("data-productname");
          let productPrice = $(this)
            .parents(".mobile_wishlist_button")
            .attr("data-productprice");
          let ProductVariant = $(this)
            .parents(".mobile_wishlist_button")
            .attr("data-variant");
          let ProductVendor = $(this)
            .parents(".mobile_wishlist_button")
            .attr("data-productVendor");
          let ProductModel = $(this)
            .parents(".mobile_wishlist_button")
            .attr("data-productmodel");
          var ProductModelHtml;
          if (ProductModel) {
            ProductModelHtml = `<p>Model: ${ProductModel}</p>`;
          } else {
            ProductModelHtml = "";
          }
          var SelectedProduct = `
            <div class="pro-select">
              <div class="pro_img">
                <img src="${productSrc}" alt="proImage">
              </div>
              <div class="pro-infor">
                <h3>${productTitle}</h3>
                <p class="selectpro_price">${productPrice} <span>ex.VAT</span></p>
                ${ProductModelHtml}
                <p>Variant: ${ProductVariant}</p>
              </div>
            </div>`;
          $(".selected_product .product_selected").html(SelectedProduct);

         
          const payload = JSON.stringify({
            shop: Shopify.shop,
            customer_id: WishlistCustomerId,
            ip: "",
            wishlist_share: "",
          });
          popup_checked_if_wishlist_exist(payload, WishlistVatiantid);
          popup_product_count(payload, WishlistVatiantid);
          let tm_popup_list_radios = document.querySelectorAll(
            ".Wishlist_popup .list_radio"
          );
          tm_popup_list_radios.forEach((radio) => {
            const checkbox = radio.querySelector(
              'input[name="wishlist-radioGroup"]'
            );
            // var DynamicStyle = `<style>
            // .MobileProductwishlistButton svg path:last-child{fill: ff819c!important;}
            // .MobileProductwishlistButton svg path:first-child{fill:transparent;}
            // </style>`;
            checkbox.addEventListener("change", () => {
              const selectedInputs = document.querySelectorAll(
                '.Wishlist_popup .list_radio input[name="wishlist-radioGroup"]:checked'
              );
              if (selectedInputs.length < 1) {
                $(".MobileProductwishlistButton svg path:last-child")
                  .css("fill", "#ff819c")
                  .css("important", "true");
              }
              popup_product_count(payload, WishlistVatiantid);
            });
          });
        });

        $(document).on("click", ".amazon_wishlist_trigger", function (e) {
          e.preventDefault();
          let WishlistVatiantid = $(this).data("variant_id");
          let WishlistProductid = $(this).data("product_id");
          let WishlistCustomerId = Number($("body").data("customerid"));
          
          $("#SaveToList").attr("data-variantid", WishlistVatiantid);
          $("#SaveToList").attr("data-productid", WishlistProductid);
          $("#SaveToList").attr("data-customerid", WishlistCustomerId);
          $("#create_list_main").attr("data-variantid", WishlistVatiantid);
          $("#create_list_main").attr("data-productid", WishlistProductid);
          $("#create_list_main").attr("data-customerid", WishlistCustomerId);
          
          $(".Wishlist_popup").addClass("active");
          $("input[name='wishlist-radioGroup']").prop("checked", false);
          
          if ($(".Create_new_list").hasClass("active")) {
            $(".Create_new_list").removeClass("active");
            $(".wishlist_lists").addClass("active");
            $("#create_list").show();
          }
          $("body").addClass("layer_second");
          $("body").addClass("cms-test");
          
          let productSrc = $(this).data("src");
          let productTitle = $(this).data("productname");
          let productPrice = $(this).data("productprice");
          let ProductVariant = $(this).data("variant");
          let ProductModel = $(this).data("productmodel");
          
          var ProductModelHtml = ProductModel ? `<p>Model: ${ProductModel}</p>` : "";
          
          var SelectedProduct = `
            <div class="pro-select">
              <div class="pro_img">
                <img src="${productSrc}" alt="proImage">
              </div>
              <div class="pro-infor">
                <h3>${productTitle}</h3>
                <p class="selectpro_price">${productPrice} <span>ex.VAT</span></p>
                ${ProductModelHtml}
                <p>Variant: ${ProductVariant}</p>
              </div>
            </div>`;
          $(".selected_product .product_selected").html(SelectedProduct);
          
          const payload = JSON.stringify({
            shop: Shopify.shop,
            customer_id: WishlistCustomerId,
            ip: "",
            wishlist_share: "",
          });
          popup_checked_if_wishlist_exist(payload, WishlistVatiantid);
          popup_product_count(payload, WishlistVatiantid);
        });
      },
      });
    };
    // Two retries (3 attempts total), short exponential backoff (1.5s,
    // 3s): a 65s-timeout failure is a genuine slow/down server and two
    // more 65s attempts would keep an already-struggling server busy for
    // minutes on every page view - but a fast rejection (the 403 case
    // above) clears almost immediately, so it's worth a couple of quick
    // extra tries rather than giving up on the first one.
    loadWishlistAddToListButton(2, 1500);
  }
}
// Product page change variant wishlist button
$("product-form input[name='id']").on("change", function () {
  var VariantValue = $(this).val();

  // .amazon_wishlist_trigger ("Save this item") is only rendered once at page
  // load with the initial variant's id baked into its data-variant_id
  // attribute. Unlike .tm_add_to-list / .mobile_wishlist_button (rebuilt
  // below), nothing else kept it in sync — so after switching variants it
  // kept sending the ORIGINAL variant's id to the wishlist API. If that
  // original variant was already wishlisted, the "already added" check
  // silently skipped adding the newly selected variant too.
  try {
    var variantsJsonEl = document.querySelector('variant-radios script[type="application/json"]');
    if (variantsJsonEl) {
      var variants = JSON.parse(variantsJsonEl.textContent);
      var selectedVariant = variants.find(function (v) {
        return String(v.id) === String(VariantValue);
      });
      if (selectedVariant) {
        var $trigger = $(".amazon_wishlist_trigger");
        $trigger.attr("data-variant_id", selectedVariant.id);
        $trigger.attr("data-variant", selectedVariant.title);
        $trigger.attr("data-productmodel", selectedVariant.sku);
        if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
          $trigger.attr("data-src", selectedVariant.featured_image.src);
        }
        // selectedVariant.price (from the variant-radios JSON blob) is
        // Shopify's raw/base price - it ignores the tag/metafield trade
        // discount new_product_page_section.liquid computes per variant via
        // tmp_discount/tmp_variant. That discounted figure is already in the
        // DOM for every variant (the hidden .price_variant--{id} elements
        // built for global.js's own price-switching), so read it from there
        // instead - same source of truth, no second (wrong) price.
        var $tradePriceEl = $(".price_variant--" + selectedVariant.id);
        var tradePriceCents = $tradePriceEl.length ? parseFloat($tradePriceEl.attr("data-price")) : NaN;
        var priceCents = !isNaN(tradePriceCents) ? tradePriceCents : selectedVariant.price;
        if (priceCents) {
          $trigger.attr("data-productprice", "£" + (priceCents / 100).toFixed(2));
        }
      }
    }
  } catch (e) {
    console.error("Failed to sync wishlist trigger with selected variant:", e);
  }

  var ProductPageProductId = $(".tm_add_to-list").data("product_id");
  var ProductObject = {};
  ProductObject[VariantValue] = ProductPageProductId;
  var productData = {
    shop: Shopify.shop,
    product_ids: ProductObject,
    customer_id: Number($("body").data("customerid")),
  };
  $.ajax({
    type: "POST",
    url: "https://wishlist.webcontrive.com/wishlist-club/public/api/v1/setting1",
    data: productData,
    dataType: "json",
    success: function (response) {
      var wishLists = response.data.wishlist;
      var productData = response.data.products[0];
      var ProductWishlisted = productData.wishlisted;
      var ProductMainVariantId = productData.shopify_variant_id;
      var ProductMainId = productData.shopify_product_id;
      var AppendWishlistButton, MobileWishlistButton;

      AppendWishlistButton = `<div class="second_wishlist_button${ProductWishlisted ? ' added' : ''}" data-product_id="${ProductMainId}" data-variant_id="${ProductMainVariantId}">
                                <div class="tm-wishlist-container">
                                  <div class="tm-wishlist-main th_wl_button_trigger">Add to List</div>
                                  <div class="tm-wishlist-arrow">
                                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1 1L5 5L9 1" stroke="#0F1111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                  </div>
                                  <div class="tm-wishlist-dropdown" >
                                    <ul class="tm-wishlist-dropdown-items">
                                      ${wishLists.map(list => 
                                        `<li class="tm-wishlist-item ${list.is_active ? 'active' : ''}" data-list-id="${list.id}">
                                          <a href="/pages/wishlist?wishlistview=${list.id}">${list.name}</a>
                                        </li>`
                                      ).join('')}
                                    </ul>
                                    <div class="tm-wishlist-create-new" id="create_new_list_trigger">
                                      <a href="#"><span>+</span> Create another Wish List</a>
                                      <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L5 5L1 9" stroke="#555" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                      </svg>
                                    </div>
                                  </div>
                                </div>
                              </div>`;
      MobileWishlistButton = `<span class="MobileProductwishlistButton" data-product_id="${ProductMainId}" data-variant_id="${ProductMainVariantId}">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M18.2849 8.26802C21.2839 4.26612 14.2838 -1.73517 10.2848 5.26483C6.05908 -1.45699 -1.5 3.5 1.78337 8.26802L10.059 18.543L18.2849 8.26802Z" stroke="black"/>
        </svg>
      </span>`;

      $(".tm_add_to-list").html(AppendWishlistButton);
      $(".mobile_wishlist_button").html(MobileWishlistButton);
    },
  });
});

//if($("body").hasClass("customer_login")){
$(document).ready(function () {
  WishlistAPI();
});

//}
$(document).on("click", ".close_wishlist_popup", function () {
  $(".Wishlist_popup").removeClass("active");
  $("body").removeClass("overflow-hidden-mobile");
  $("body").removeClass("layer_second");
  $(".Create_new_list input#New_list").val("");
  localStorage.removeItem("saveForLater");
});
$(document).on("click", "#create_list", function () {
  $(".Create_new_list").addClass("active");
  $(this).hide();
  $(".Wishlist_popup .wishlist_lists").removeClass("active");
  $(".ListName input").focus();
});

// cod eby jv------

document.addEventListener("DOMContentLoaded", function () {
setTimeout(() => {  
  let selectedRadios = document.querySelectorAll('.wishlist_lists input[name="wishlist-radioGroup"]');
  console.log("selectedRadio----",selectedRadios);

  selectedRadios.forEach(function(selectedRadio){
    selectedRadio.addEventListener("change", function(){
      console.log("change event fired");
    });
  });  
  },1000);
});

document.addEventListener("DOMContentLoaded", function () {
document.querySelector("#SaveToList").addEventListener("click",check_wishlist); 
check_wishlist();
  
  function check_wishlist(){
  console.log("called function---");
  let wishlistData = JSON.parse(localStorage.getItem("tmWishlistPage"));
  let variantIds = [];

  // Check if wishlistData is available
    if (wishlistData && wishlistData.data && wishlistData.data.wishlists) {
      wishlistData.data.wishlists.forEach(wishlist => {
          wishlist.wishlists.forEach(item => {
              variantIds.push(item.variant_id);
          });
      });
    }

  console.log("All Variant IDs:", variantIds);

// setTimeout(() => {
// let wishlistButton = document.querySelector(".MobileProductwishlistButton");
// let wishlistButton_variant_id = wishlistButton.getAttribute("data-variant_id");
// console.log("All Variant IDs-----:", wishlistButton_variant_id);


//   if (variantIds.includes(wishlistButton_variant_id)) {
//     console.log(`Variant ID ${wishlistButton_variant_id} is present in the array.`);
//     let svgPath = wishlistButton.querySelector("svg path");
//         if (svgPath) {
//           svgPath.style.setProperty("fill", "#000", "important");
//           console.log("SVG color updated.");
//         } else{
//           console.log("No SVG found inside the button.");
//         }
//       } 
//       else {
//         console.log(`Variant ID ${wishlistButton_variant_id} is NOT present in the array.`);
//       }
//   }, 2000);
}

});